/**
 * @generated SignedSource<<45be4bc40ca5a0bd4d033aef68435192>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkstreamArchiveMutation$variables = {
  id: number;
};
export type WorkstreamArchiveMutation$data = {
  readonly archiveWorkstream: {
    readonly workstream: {
      readonly archived: boolean;
      readonly id: number;
      readonly name: string;
    } | null | undefined;
  };
};
export type WorkstreamArchiveMutation = {
  response: WorkstreamArchiveMutation$data;
  variables: WorkstreamArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "UpdateWorkstreamResult",
    "kind": "LinkedField",
    "name": "archiveWorkstream",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "workstreams",
        "kind": "LinkedField",
        "name": "workstream",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkstreamArchiveMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkstreamArchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0e80b220310c46173c225e2a3aa57455",
    "id": null,
    "metadata": {},
    "name": "WorkstreamArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation WorkstreamArchiveMutation(\n  $id: Int!\n) {\n  archiveWorkstream(id: $id) {\n    workstream {\n      id\n      name\n      archived\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9bfbed6ba1882b2755a4ee4569c82ec2";

export default node;
